// extracted by mini-css-extract-plugin
export default {"bankField":"CryptoWalletDetails_bankField__TbwEL"};